import { render, staticRenderFns } from "./StorageRoomEdit.vue?vue&type=template&id=01f46891"
import script from "./StorageRoomEdit.vue?vue&type=script&lang=js"
export * from "./StorageRoomEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports